<script setup>
import { useI18n } from 'vue-i18n';
import AutomationActionInput from 'dashboard/components/widgets/AutomationActionInput.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import useAutomationValues from 'dashboard/composables/useAutomationValues';
import {
  getFileName,
  showActionInput,
} from 'dashboard/helper/automationHelper';

// The list of actions a rule performs once its conditions hold.
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  actionTypes: {
    type: Array,
    default: () => [],
  },
  // Attachments already stored on the rule, so an edited rule shows the file
  // it was saved with rather than an empty picker.
  files: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['update:modelValue', 'reset', 'remove', 'add']);

const { t } = useI18n();
const { getActionDropdownValues, agents, teams } = useAutomationValues();

const setAction = (index, value) =>
  emit(
    'update:modelValue',
    props.modelValue.map((action, i) => (i === index ? value : action))
  );

const errorFor = index =>
  props.errors[`action_${index}`]
    ? t(`AUTOMATION.ERRORS.${props.errors[`action_${index}`]}`)
    : '';
</script>

<template>
  <div>
    <AutomationActionInput
      v-for="(action, i) in modelValue"
      :key="i"
      :model-value="action"
      :action-types="actionTypes"
      :dropdown-values="getActionDropdownValues(action.action_name)"
      :show-action-input="showActionInput(actionTypes, action.action_name)"
      :initial-file-name="getFileName(action, files)"
      :error-message="errorFor(i)"
      :agents="agents"
      :teams="teams"
      @update:model-value="setAction(i, $event)"
      @reset-action="$emit('reset', i)"
      @remove-action="$emit('remove', i)"
    />
    <div class="mt-4">
      <NextButton
        icon="i-lucide-plus"
        blue
        faded
        sm
        :label="$t('AUTOMATION.ADD.ACTION_BUTTON_LABEL')"
        @click="$emit('add')"
      />
    </div>
  </div>
</template>
